<a [href]="fremdsystem.url" class="btn btn-outline-primary btn-sm btn-actionpane" target="_blank"
   *ngFor="let fremdsystem of fremdsysteme|async|fremdsystemVisibility"><em
  [class]="fremdsystem.icon"></em> {{fremdsystem.label}}</a>
